import { graphql } from 'react-relay';
import get from 'lodash.get';

const RINGS_LABEL = 'rings';
const ITEM_PRICE_THRESHOLD_USD = 20000;

export const viewerFragment = graphql`
    fragment consultAnExpert_viewer on Viewer {
        isConsultAnExpertDisabled: isEnabledByLocale(featureName: "DISABLE_CONSULT_AN_EXPERT")
    }
`;

export const itemFragment = graphql`
    fragment consultAnExpert_item on Item {
        isJewelry
        getCategoriesByLevel(level: 2) {
            label
        }
        pricing {
            totalAmount {
                convertedAmounts {
                    USD
                }
            }
        }
    }
`;

export const shouldShowConsultAnExpert = ({ viewer, item }) => {
    const isRing =
        get(item, 'isJewelry') && get(item, 'getCategoriesByLevel[0].label') === RINGS_LABEL;
    const totalAmountInUSD = get(item, 'pricing.totalAmount.convertedAmounts.USD');

    return (
        isRing &&
        totalAmountInUSD > ITEM_PRICE_THRESHOLD_USD &&
        !get(viewer, 'isConsultAnExpertDisabled')
    );
};

export const shouldLaunchConsultAnExpert = () => {
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const consultAnExpertParam = urlParams.get('consultAnExpert') || '';

        return consultAnExpertParam.toLowerCase() === 'true';
    }

    return false;
};
